import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { CommonService } from 'src/app/services/common.service';
import { FormsService } from 'src/app/services/forms.service';
import {
  EntityType,
  ResponseMessageStatus,
  ResponseStatus,
  SortBy,
} from 'src/app/shared/enums';
import { BadeLoftService } from '../bade-loft.service';
//import * as FileSaver from 'file-saver';
import { Router } from '@angular/router';
import { NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-warehouse',
  templateUrl: './warehouse.component.html',
  styles: [],
})
export class WarehouseComponent implements OnInit {
  lst_StockLocation: any = [];
  isShowArchiveStock: boolean = false;
  isVisibleAddWarehouse = false;
  isStockNameValid: boolean = true;
  physicalInventoryisVisible: boolean = false;
  uploadFile: boolean = true;
  previewFile: boolean = false;
  lst_Warehouse: any = [];
  isAuditVisible: boolean = false;
  lst_Parts: any = [];
  lst_PartNumber: any = [];
  pageSize: number = 100;
  isPartNumberExist: boolean = false;
  assignmentDetails: any;
  lst_Dashboard: any = [];
  page: number = 1;
  entityDetails: any;
  entityType: number = EntityType.warehouse;
  stockMaxPageSize: number = 0;
  isStockLoaded: boolean;
  timer: any = null;
  searchText: string = '';
  stockList_Request: any;
  oldSearchText: string = '';
  sortField: string = 'name';
  sortBy: number = SortBy.Asc;
  isDashboardLoaded: boolean = false;
  assignedData: any;
  getassigment: any;
  http: any;
  pdfResult: any;
  totalRecord: number = 0;
  fileReaded: any;
  records: any;
  shortLink: any;
  loading: boolean;
  dif: number;
  formData: FormData = new FormData();
  nzMultiple = false;
  isDisabled: boolean = true;
  fileNmae: boolean = false;
  @ViewChild('fileReadedJS') fileReadedJS: any;
  uploadedPartsFile: any;
  isVisiblePartsModal: boolean = false;
  isImportingParts: boolean = false;
  isSyncingPrices: boolean = false;
  isPhysicalModal: boolean = false;
  isConvertingFile: boolean = false;
  CSVFileBase64: any;
  // file Upload

  onUpload() {    
    this.formData = new FormData();
    this.formData.append(this.fileReaded, this.fileReaded);
    this._blS
      .ImportPhysicalInventoryFile(this.formData)
      .subscribe((res: any) => {
        if (res.responseStatus == ResponseStatus.Success && res) {
          this.physicalInventoryisVisible = false;
          this._cS.displayMessage(ResponseMessageStatus.success, res.message);
          this.lst_Warehouse = [];
          var data = res.result.records;
          if (data && data.length > 0) {
            data.forEach((x: any) => {
              this.lst_Warehouse.push(x);
            });
          }
          this.totalRecord = res.result.totalRecord;
          this.stockMaxPageSize = res.result.totalPage;
          this.lst_Warehouse.map((p: any) => (p.visibleAssigned = false));

          this.formData = new FormData();
          this.previewFile = false;
          this.uploadFile = true;
          this.records = null;
          this.fileNmae = false;
          // this.lst_Warehouse = [...this.fileReaded];
          if (this.fileReaded == null) {
            this.isDisabled = false;
          } else {
            this.isDisabled = true;
          }
          this.isVisibleAddWarehouse = false;
        } else {
          this._cS.displayMessage(ResponseMessageStatus.error, res.message);
        }
        this.fileReaded = null;
      });
  }

  // The CSV is sent to the API by importParts() when the user clicks Save, so
  // nz-upload must not post it anywhere itself. Overriding nzCustomRequest keeps
  // the file-list tile and the (nzChange) capture working while making no network
  // call at all. onSuccess is deferred because nz-upload only adds the file to
  // nzFileList in its own onStart(), which runs after this returns.
  customRequest = (item: NzUploadXHRArgs): Subscription => {
    const timer = setTimeout(() => item.onSuccess!(null, item.file!, null));
    return new Subscription(() => clearTimeout(timer));
  };

  handleChange(event: any) {
    if (event.fileList.length > 0) {
      var fileNameSplit = event.file.name.split('.');
      if (fileNameSplit[fileNameSplit.length - 1] == 'csv') {
        this.uploadedPartsFile = event.file.originFileObj;
        if (event.fileList.length > 1) {
          event.fileList.splice(event.fileList.length - 2, 1);
        }
      } else {
        event.fileList.splice(event.fileList.length - 1, 1);
        this._cS.displayMessage(
          ResponseMessageStatus.warning,
          'Only CSV file type is allowed'
        );
      }
    }
  }

  uploadListener(csv: any) {
    this.fileReaded = csv.target.files[0];
    if (this.fileReaded.name != '') {
      this.fileNmae = true;
    } else {
      this.fileNmae = false;
    }
    try {
      var data = csv.target.files[0];
      var fileNameSplit = data.name.split('.');
      if (fileNameSplit[fileNameSplit.length - 1] != 'csv') {
        this._cS.displayMessage(
          ResponseMessageStatus.error,
          'Only CSV file type is allowed'
        );
        this.isDisabled = true;
      } else {
        let reader: FileReader = new FileReader();
        reader.readAsText(this.fileReaded);
        reader.onload = (e) => {
          let csv: any = reader.result;
          let allTextLines = csv.split(/\r|\n|\r/);
          let headers = allTextLines[0].split(',');
          let lines = [];
          for (let i = 0; i < allTextLines.length; i++) {
            let data = allTextLines[i].split(',');
            if (data.length === headers.length) {
              let tarr = [];
              for (let j = 0; j < headers.length; j++) {
                tarr.push(data[j]);
              }
              lines.push(tarr);
            }
          }
          this.records = lines;
          if(this.isPhysicalModal){
          this.isDisabled = false }else{
            this.isConvertingFile= false;
          }
        };
      }
    } catch (error) {}
  }

  // -----

  DownloadPhysicalInventoryTemplate() {
    this._blS.DownloadPhysicalInventoryTemplate().subscribe((response: any) => {
      let byteCharacters = atob(response.byteFile);
      let byteNumbers = new Array(byteCharacters.length);
      for (var i = 0; i < byteCharacters.length; i++)
        byteNumbers[i] = byteCharacters.charCodeAt(i);

      let byteArray = new Uint8Array(byteNumbers);
      let blob = new Blob([byteArray], { type: response.contentType });

      var blobURL = window.URL.createObjectURL(blob);
      var anchor = document.createElement('a');
      anchor.download = response.fileName;
      anchor.href = blobURL;
      anchor.click();
    });
  }

  onQueryParamsChange(event: any) {
    this.pageSize = this.pageSize;
    this.page = event;
    this.getWarehouseList();
  }

  onScrollDown() {
    if (this.page != this.stockMaxPageSize) {
      this.page += 1;
      this.getWarehouseList();
    }
  }

  onSearch(event: any) {
    if (event.which != 9 && event.which != 18 && event.which != 27) {
      clearTimeout(this.timer);
      if (this.searchText.trim().length >= 3) {
        this.timer = setTimeout(() => {
          this.page = 1;
          this.lst_Warehouse = [];
          if (this.stockList_Request) this.stockList_Request.unsubscribe();
          this.getWarehouseList();
        }, 1000);
      } else {
        if (this.searchText == '') {
          this.page = 1;
          this.lst_Warehouse = [];
          this.oldSearchText = '';
          if (this.stockList_Request) this.stockList_Request.unsubscribe();
          this.getWarehouseList();
        }
      }
    }
  }

  changewarehouseAssigned(event: any, i: number) {
    if (this.lst_Warehouse[i].assignedQuantity > 0) {
      this.lst_Warehouse[i].visibleAssigned = event;
      if (
        this.lst_Warehouse[i].visibleAssigned &&
        !this.lst_Warehouse[i].assignedData
      ) {
        this._blS
          .GetPartNumberAssignmentDetail(this.lst_Warehouse[i].partNumber)
          .subscribe((res) => {
            if (res) {
              if (res.responseStatus == ResponseStatus.Success) {
                this.lst_Warehouse[i].assignedData =
                  res.result && res.result.length > 0 ? res.result : [];
                // this.warehouserList[i]['assignmentList'] =
                //   res.result && res.result.length > 0
                //     ? res.result[0].assignmentList
                //     : [];
              }
            }
          });
      }
    }
  }

  GetAssignmentDetails(id: any, partNumber: any, i: any) {
    this._blS.GetAssignmentDetails(id, partNumber).subscribe((res) => {
      if (res) {
        res.result;
      }
      {
        this.lst_Warehouse[i]['assignmentList'] =
          res.result && res.result.length > 0 ? res.result : [];
      }
    });
  }

  sort(key: string) {
    if (key) {
      this.sortBy = this.sortBy == SortBy.Asc ? SortBy.Dsc : SortBy.Asc;
      this.sortField = key;
      this.page = 1;
      this.lst_Warehouse = [];
      if (this.stockList_Request) this.stockList_Request.unsubscribe();
      this.getWarehouseList();
    }
  }

  getWarehouseList() {
    this.isDashboardLoaded = true;
    this._cdref.detectChanges();
    this.stockList_Request = this._blS
      .getWarehouseList(
        encodeURIComponent(this.searchText.trim()),
        this.sortField,
        this.sortBy,
        this.page,
        this.pageSize,
        false
      )
      .subscribe((res) => {
        if (res) {
          if (res.responseStatus == ResponseStatus.Success && res.result) {
            // this._cS.displayMessage(ResponseMessageStatus.success, res.message);
            var data = res.result.records;
            if (data && data.length > 0) {
              data.forEach((x: any) => {
                this.lst_Warehouse.push(x);
              });
            }
            this.totalRecord = res.result.totalRecord;
            this.stockMaxPageSize = res.result.totalPage;
            this.lst_Warehouse.map((p: any) => (p.visibleAssigned = false));
          } else {
            this._cS.displayMessage(ResponseMessageStatus.error, res.message);
          }
          this.isDashboardLoaded = false;
        }
      });
  }
  uploadedCSVInfo(event: any) {
    try {
      var data = event.fileList[0];
      var fileNameSplit = data.name.split('.');
      if (fileNameSplit[fileNameSplit.length - 1] != 'csv') {
        this._cS.displayMessage(
          ResponseMessageStatus.error,
          'Only CSV file type is allowed'
        );
      } else {
        this.uploadedPartsFile = event.fileList[0].originFileObj;
      }
    } catch (error) {}
  }
  importParts() {
    this.isImportingParts = true;
    const formData = new FormData();
    formData.append(this.uploadedPartsFile.name, this.uploadedPartsFile);
    this._blS.importPart(formData).subscribe((response: any) => {
      if (response) {
        if (response.responseStatus == ResponseStatus.Success) {
          this.isImportingParts = false;
          this.page = 1;
          this.lst_Warehouse = [];
          this.getWarehouseList();
          this.isVisiblePartsModal = false;
          this._cS.displayMessage(
            ResponseMessageStatus.success,
            response.message
          );
        } else {
          this.isImportingParts = false;
          this._cS.displayMessage(
            ResponseMessageStatus.error,
            response.message
          );
        }
      }
    });
  }
  syncRetailPrices(): void {
    this.isSyncingPrices = true;
    this._blS.syncRetailPrices().subscribe({
      next: (res: any) => {
        if (res && res.responseStatus === ResponseStatus.Success) {
          this._cS.displayMessage(ResponseMessageStatus.success, res.message);
          this.page = 1;
          this.lst_Warehouse = [];
          this.getWarehouseList();
        } else {
          this._cS.displayMessage(ResponseMessageStatus.error, res?.message ?? 'Sync failed.');
        }
      },
      error: () => {
        this._cS.displayMessage(ResponseMessageStatus.error, 'Retail price sync failed. Please try again.');
      },
      complete: () => {
        this.isSyncingPrices = false;
      }
    });
  }
  getPartNumbers() {
    try {
      this._blS.GetPartNumbers().subscribe((res) => {
        if (res) {
          if (res.responseStatus == ResponseStatus.Success && res.result) {
            this.lst_Parts = res.result;
          } else {
            this._cS.displayMessage(ResponseMessageStatus.error, res.message);
          }
        }
      });
    } catch (error) {}
  }

  onSelectPartNumber(event: any) {
    var part = this.lst_Parts.find((p: any) => p.value == event);
    if (part) {
      var partIndex = this.lst_PartNumber.findIndex(
        (x: any) => x.partNumber == part.text
      );
      if (partIndex > -1) {
        this.isPartNumberExist = true;
      } else {
        this.isPartNumberExist = false;
      }
    }
  }
  showHistoryModal(data: any) {
    this.isAuditVisible = true;
    this.entityDetails = data;
  }

  hideAuditModal(event: any) {
    this.isAuditVisible = !event.hide;
  }

  showModal(): void {
    this.isVisibleAddWarehouse = true;
  }

  AddWarehouseOk(): void {
    this._cS.markFormGroupTouched(this._fS.addWarehouseStock);
    if (this._fS.addWarehouseStock.valid) {
      var formValue = this._fS.addWarehouseStock.value;
      var part = this.lst_Parts.find(
        (p: any) => p.value == formValue.partNumber
      );

      var body = {
        partNumber: part.text,
        availableQuantity: formValue.orderQuantiry,
        assignedQuantity: 0,
        note: formValue.notes ? formValue.notes.trim() : '',
      };
      this._blS.SaveWarehouseStock(body).subscribe((res) => {
        if (res) {
          if (res.responseStatus == ResponseStatus.Success && res.result) {
            var warehouseIndex = this.lst_Warehouse.findIndex(
              (x: any) => x.partNumber == body.partNumber
            );
            if (warehouseIndex > -1) {
              this.lst_Warehouse[warehouseIndex] = {
                id: part.value,
                partNumber: res.result.partNumber,
                availbleQuantity:
                  res.result.physicalPartQuantity - res.result.assignedQuantity,
                assignedQuantity: res.result.assignedQuantity,
                physicalPartQuantity: res.result.physicalPartQuantity,
                note: res.result.note ? res.result.note.trim() : '',
              };
            } else {
              this.lst_Warehouse.push({
                id: part.value,
                partNumber: part.text,
                availbleQuantity: res.result.physicalPartQuantity,
                assignedQuantity: 0,
                physicalPartQuantity: res.result.physicalPartQuantity,
                note: formValue.notes ? formValue.notes.trim() : '',
              });
            }

            this.lst_Warehouse = [...this.lst_Warehouse];
            this._fS.addWarehouseStock.reset();
          } else {
            this._cS.displayMessage(ResponseMessageStatus.error, res.message);
          }
        }
      });
      this.lst_Warehouse = [...this.lst_Warehouse];
      this.isVisibleAddWarehouse = false;
    } else {
      this.isVisibleAddWarehouse = true;
    }
  }

  AddWarehouseCancel(): void {
    this.isVisibleAddWarehouse = false;
    this._fS.addWarehouseStock.reset();
  }

  physicalInventoryShow(isPhysicalModal:boolean): void {
    this.fileReaded = null;
    this.formData = new FormData();
    this.physicalInventoryisVisible = true;
    this.isPhysicalModal = isPhysicalModal;
    this.fileReadedJS.nativeElement.value = '';
    if (this.fileReaded == null) {
      this.isDisabled = true;
    } else {
      this.isDisabled = false;
    }
  }

  physicalInventoryOk(): void {
    this.uploadFile = false;
    if(this.isPhysicalModal){
    this.previewFile = true;
    }
    if (this.fileReaded == null) {
      this.isDisabled = true;
    } else {
      this.isDisabled = false;
    }
  }

  convertCSVFile(){
    this.formData = new FormData();
    this.formData.append(this.fileReaded, this.fileReaded);
    this._blS
      .ConvertWayfairCSVFile(this.formData)
      .subscribe((res: any) => {
        if(res.byteFile){
        this.CSVFileBase64 = res;
          this._cS.displayMessage(ResponseMessageStatus.success, 'File converted successfully');
            this.isDisabled = false;
        }else{
          this._cS.displayMessage(ResponseMessageStatus.error, res.message);
        }
      });
  }

  converFileOk(){
    this.uploadFile = false;
    let byteCharacters = atob(this.CSVFileBase64.byteFile);
    let byteNumbers = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++)
      byteNumbers[i] = byteCharacters.charCodeAt(i);

    let byteArray = new Uint8Array(byteNumbers);
    let blob = new Blob([byteArray], { type: this.CSVFileBase64.contentType });

    var blobURL = window.URL.createObjectURL(blob);
    var anchor = document.createElement('a');
    anchor.download = this.fileReaded?.name.split('.')[0] + '.xlsx';
    anchor.href = blobURL;
    anchor.click();
    this.physicalInventoryisVisible = false;
    this.fileReaded = null;
    this.uploadFile = true;
    this.isPhysicalModal = false;
    this.isConvertingFile= false;
    this.fileNmae = false;
    this.physicalInventoryCancel()

  }

  physicalInventoryCancel(): void {
    this.physicalInventoryisVisible = false;
    //this.uploadFile = true;
    this.uploadFile = true;
    this.previewFile = false;
    this.records = null;
    this.fileNmae = false;
    this.fileReaded = null;
    if (this.fileReaded == null) {
      this.isDisabled = false;
    } else {
      this.isDisabled = true;
    }
  }

  archiveStock(data: any, i: number) {
    this._blS.UpdateStockAsArchive(data.id).subscribe((res) => {
      if (res) {
        if (res.responseStatus == ResponseStatus.NotFound && res.result) {
        }
      }
    });
  }
  isAssignmentVisible: boolean = false;
  editAssignmentDetail: any = null;
  showAssignmentEdit(assignment: any) {
    // this._router.navigate(['/bade-loft/assignment'], {
    //   queryParams: { invoiceNumber: invoice },
    // });
    this.isAssignmentVisible = true;
    this.editAssignmentDetail = assignment;
    this.editAssignmentDetail['assigmentDetails'] = true;
  }

  hideModal(event: any) {
    if (event.hide) {
      this.isAssignmentVisible = !event.hide;
      if (event.data) {
        this.lst_Warehouse = [];
        this.getWarehouseList();
      }
    }
  }

  handleOk() {
    this.importParts();
  }
  handleCancel() {
    this.isVisiblePartsModal = false;
  }
  downloadFile() {
    let link = document.createElement('a');
    link.download = 'samplePartsimport.csv';
    link.href = 'assets/sampleImportParts.csv';
    link.click();
  }

  constructor(
    public _fS: FormsService,
    public _cS: CommonService,
    private msg: NzMessageService,
    private _blS: BadeLoftService,
    private _cdref: ChangeDetectorRef,
    private _router: Router
  ) {
    _fS.addWarehouseStock_Fb();
  }

  ngOnInit(): void {
    this.lst_StockLocation = this._cS.lst_StockLocation;
    var preReservedData: any = null;
    preReservedData = this._cS.getLocalStorageItem('stock_data');
    if (preReservedData) {
      preReservedData = JSON.parse(preReservedData);
      // this.page = preReservedData.page;
      // this.pageSize = preReservedData.pageSize;
      this.searchText = preReservedData.searchText;
      this.sortBy = preReservedData.sortBy;
      this.sortField = preReservedData.sortField;
      this.isShowArchiveStock = preReservedData.isShowArchiveStock
        ? preReservedData.isShowArchiveStock
        : this.isShowArchiveStock;
    }
    this.getWarehouseList();
  }
}
function char(char: any): Iterable<number> {
  throw new Error('Function not implemented.');
}
